import { useMutation } from "@pinia/colada";

import { toApiLocale, useWidgetContext } from "@/shared/config";
import { useApiGetWidgetData } from "@/shared/model";

import { apiSendStatusAnswer } from "../api";
import { useEvaluationStore } from "./evaluation";

/** Ответить на вопрос о состоянии устройства и получить цену выкупа по ответу */
export function useApiSendStatusAnswer() {
    const { settings } = useWidgetContext();
    const { data: widgetData } = useApiGetWidgetData();
    const evaluationStore = useEvaluationStore();

    return useMutation({
        mutation: (payload: { questionId: string; optionId: string }) =>
            apiSendStatusAnswer({
                deviceId: evaluationStore.registeredDevice?.deviceId ?? "",
                token: widgetData.value?.token ?? "",
                lang: toApiLocale(settings.locale),
                questionId: payload.questionId,
                c: payload.optionId,
            }),
        onSuccess: (device, { optionId }) => evaluationStore.setAnsweredDevice(device, optionId),
    });
}
